import { post } from "@/utils/utils";
import moment from "moment";

const merchant = {
  state: {
    merchantList: [],
    addMerchantCode: "",
    editMerchantCode: "",
    storeRemind: "",
    editRemindCode: "",
    rechargeList: [],
    rechargeCode: "",
    expiredDate: "",
    accountList: [],
    addAccountCode: "",
    editAccountCode: "",
    deleteAccountCode: "",
    oldMerchantList: []
  },
  mutations: {
    MERCHANT_LIST(state, data) {
      state.merchantList = data.result;
      state.merchantList.list.forEach(v => {
        v.expiredDateFormat = v.expiredDate
          ? moment(v.expiredDate).format("YYYY-MM-DD")
          : "";
        v.statusFormat = v.status === 0 ? "关闭" : "开启";
      });
    },
    OLD_MERCHANT_LIST(state, data) {
      state.oldMerchantList = data.result;
    },
    ADD_MERCHANT(state, data) {
      state.addMerchantCode = data.result;
    },
    EDIT_MERCHANT(state, data) {
      state.editMerchantCode = data.result;
    },
    DELETE_MERCHANT(state, data) {
      state.deleteMerchantCode = data.result;
    },
    STORE_REMIND(state, data) {
      state.storeRemind = data.result;
    },
    EDIT_REMIND(state, data) {
      state.editRemindCode = data.result;
    },
    RECHARGE_LIST() {},
    QUERY_BALANCE() {},
    OUTPUT_ACCOUNT() {},
    RECHARGE(state, data) {
      state.rechargeCode = data.result;
    },
    ACCOUNT_LIST(state, data) {
      state.accountList = data.result;
    },
    ADD_ACCOUNT(state, data) {
      state.addAccountCode = data.result;
    },
    EDIT_ACCOUNT(state, data) {
      state.editAccountCode = data.result;
    },
    DELETE_ACCOUNT(state, data) {
      state.deleteAccountCode = data.result;
    },
    EDIT_NOTICE(state, data) {
      state.editNoticeCode = data.result;
    },
    SHOW_NOTICE(state, data) {
      state.nocie = data.result;
    },
    QUERY_ALL_RECHARGE_LIST() {},
    QUERY_DEDUCT_LIST() {},
    QUERY_ALL_DEDUCT_LIST() {},
    GONGHAIMEBERNUM() {},
    GONGHAIMEMBERINFO() {},
    GONGHAIGUIDER() {},
    GONGHAIINIT() {},
    GONGHAIECHARTS() {},
    GONGHAISTOREINIT() {},
    GONGHAIASSIGNRULEINFO() {},
    GONGHAIUNASSIGNRULEINFO() {},
    GONGHAIASSIGNGUIDERRECODRD() {},
    GONGHAIAUNSSIGNGUIDERRECODRD() {},
    EMPLOYEE_STATISTICS_LIST() {},
    ORG_STATISTICS_LIST() {},
    HIGH_SEAS_ALL_RECORD() {},
    MEMBER_LIST_EXPORT() {},
    WECHARTINDEXHEAD() {},
    WECHARTINDEXSTATISTIC() {},
    GONGHAIASSIGRULECONFIG() {},
    GONGHAIASSIUNGRULECONFIG() {},
    GONGHAISTATISTICSMEMBER() {},
    GONGHAISTATISTICSMEMBERNUM() {},
    WECHARTGETSUITEYOKEN() {},
    TAGDELETETAGDATA() {},
    QUERY_DICT_ITEMS_CODE() {},
    BUY_SERVICE_PROJECT() {},
    QUERY_ACCOUNT_MONEY_USE_RECORD_List() {},
    COMPANY_WECHAT_INSTALL() {},
    QUERY_QYWX_FRIEND_SWITCH() {},
    EDIT_QYWX_FRIEND_SWITCH() {},
    STOREBASICINFO_INFO() {},
    CASH_OUT_APPLY() {},
    CASH_OUT_LIST() {},
    CASH_OUT_OPERATE() {},
  },
  actions: {
    // 清空标签数据
    emptyTags({ commit }, params) {
      return post({
        commit,
        url: "/tag/deleteTagData",
        name: "TAGDELETETAGDATA",
        params,
        isAdmin: true
      });
    },
    // 企业微信 获取第三方应用凭证
    wechartGetSuiteToken({ commit }, params) {
      return post({
        commit,
        url: "/company/wechat/getSuiteToken",
        name: "WECHARTGETSUITEYOKEN",
        params,
        isAdmin: true
      });
    },
    // 企业微信 企业统计报表
    wechartStatistic({ commit }, params) {
      return post({
        commit,
        url: `/company/wechat/qy/index/statistic`,
        name: "WECHARTINDEXSTATISTIC",
        params,
        isAdmin: true
      });
    },
    // 企业微信
    wechartHead({ commit }, params) {
      return post({
        commit,
        url: `/company/wechat/qy/index/head`,
        name: "WECHARTINDEXHEAD",
        params,
        isAdmin: true
      });
    },
    // 公海会员-查询公海会员数
    getgonghaiSeasMeberNum({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/queryHighSeasMemberNum`,
        name: "GONGHAISTATISTICSMEMBERNUM",
        params,
        isAdmin: true
      });
    },
    // 公海会员统计
    getgonghaiSeasMeber({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/statisticsHighSeasMember`,
        name: "GONGHAISTATISTICSMEMBER",
        params,
        isAdmin: true
      });
    },
    // 取消绑定导购记录
    getgonghaiUnAssignList({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/unassignGuiderRecord`,
        name: "GONGHAIAUNSSIGNGUIDERRECODRD",
        params,
        isAdmin: true
      });
    },
    // 查询职员业绩统计
    getEmployeeStatisticsList({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/queryAssignStatisticsToEmployee`,
        name: "EMPLOYEE_STATISTICS_LIST",
        params,
        isAdmin: true
      });
    },
    // 查询机构业绩统计
    getOrgStatisticsList({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/queryAssignStatisticsToShop`,
        name: "ORG_STATISTICS_LIST",
        params,
        isAdmin: true
      });
    },
    gonghaiAssignRecordExport({ commit }, params) {
      return post({
        commit,
        url: `/reports/daystatOrderDetails/highSeasMemberAssignRecordExport`,
        name: "HIGH_SEAS_ALL_RECORD",
        params
      });
    },
    memberListExport({ commit }, params) {
      return post({
        commit,
        url: `/reports/daystatOrderDetails/memberListExport`,
        name: "MEMBER_LIST_EXPORT",
        params
      });
    },
    // 客户出公海分配导购记录
    getgonghaiAssignList({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/assignGuiderRecord`,
        name: "GONGHAIASSIGNGUIDERRECODRD",
        params,
        isAdmin: true
      });
    },
    // 公海获取商城取消分配规则
    getgonghaiUnRuleInfo({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/queryStoreUnAssignRuleInfo`,
        name: "GONGHAIUNASSIGNRULEINFO",
        params,
        isAdmin: true
      });
    },
    // 公海 获取商城分配规则
    getgonghaiRuleInfo({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/queryStoreAssignRuleInfo`,
        name: "GONGHAIASSIGNRULEINFO",
        params,
        isAdmin: true
      });
    },
    // 会员取消绑定导购规则配置
    unassignRuleConfig({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/unassignRuleConfig`,
        name: "GONGHAIASSIUNGRULECONFIG",
        params,
        isAdmin: true
      });
    },

    // 公海会员分配导购配置
    assignRuleConfig({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/assignRuleConfig`,
        name: "GONGHAIASSIGRULECONFIG",
        params,
        isAdmin: true
      });
    },
    // 公海 获取商城初始化信息
    gonghaiStoreInit({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/queryStoreInitInfo`,
        name: "GONGHAISTOREINIT",
        params,
        isAdmin: true
      });
    },
    // 公海 公海会员-图表接口
    gonghaiEcharts({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/highSeasMemberEcharts`,
        name: "GONGHAIECHARTS",
        params,
        isAdmin: true
      });
    },
    // 公海 公海会员-初始化配置
    gonghaiInit({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/initConfig`,
        name: "GONGHAIINIT",
        params,
        isAdmin: true
      });
    },
    // 公海 公海会员-手动分配导购信息
    getGonghaiGuider({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/manualAssignGuider`,
        name: "GONGHAIGUIDER",
        params,
        isAdmin: true
      });
    },
    // 公海 获取手动计算完成后的数据
    getGonghaiMemberInfo({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/queryManualHighSeasMemberInfo`,
        name: "GONGHAIMEMBERINFO",
        params,
        isAdmin: true
      });
    },
    // 公海 查询公海人员
    getGonghaiMember({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/queryHighSeasMemberNum`,
        name: "GONGHAIMEBERNUM",
        params,
        isAdmin: true
      });
    },
    queryBalance({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/queryBalance`,
        name: "QUERY_BALANCE",
        params,
        isAdmin: true
      });
    },
    outputAccount({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/exportCompanyCapitalFlowList`,
        name: "OUTPUT_ACCOUNT",
        params,
        isAdmin: true
      });
    },
    editNotice({ commit }, params) {
      return post({
        commit,
        url: `/server-back/edit_sys_notice`,
        name: "EDIT_NOTICE",
        params,
        isAdmin: true
      });
    },
    showNotice({ commit }, params) {
      return post({
        commit,
        url: `/server-back/sys_notice`,
        name: "SHOW_NOTICE",
        params,
        isAdmin: true
      });
    },
    queryOldMerchantList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/old_store_list`,
        name: "OLD_MERCHANT_LIST",
        params,
        isAdmin: true
      });
    },
    queryMerchantList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/store_list`,
        name: "MERCHANT_LIST",
        params,
        isAdmin: true
      });
    },
    addMerchant({ commit }, params) {
      return post({
        commit,
        url: `/server-back/add_store`,
        name: "ADD_MERCHANT",
        params,
        isAdmin: true
      });
    },
    editMerchant({ commit }, params) {
      return post({
        commit,
        url: `/server-back/update_store`,
        name: "EDIT_MERCHANT",
        params,
        isAdmin: true
      });
    },
    deleteMerchant({ commit }, params) {
      return post({
        commit,
        url: `/server-back/delete_store`,
        name: "DELETE_MERCHANT",
        params
      });
    },
    queryStoreRemind({ commit }, params) {
      return post({
        commit,
        url: `/server-back/store_remind`,
        name: "STORE_REMIND",
        params,
        isAdmin: true
      });
    },
    editStoreRemind({ commit }, params) {
      return post({
        commit,
        url: `/server-back/edit_store_remind`,
        name: "EDIT_REMIND",
        params,
        isAdmin: true
      });
    },
    queryRechargeList({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/list`,
        name: "RECHARGE_LIST",
        params
      });
    },
    queryDeductList({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/deductList`,
        name: "QUERY_DEDUCT_LIST",
        params
      });
    },
    queryAllDeductList({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/deductList`,
        name: "QUERY_ALL_DEDUCT_LIST",
        params
      });
    },
    queryAllRechargeList({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/list`,
        name: "QUERY_ALL_RECHARGE_LIST",
        params
      });
    },
    toRecharge({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/recharge`,
        name: "RECHARGE",
        params,
        isAdmin: true
      });
    },
    queryAccoutList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/store_user_list`,
        name: "ACCOUNT_LIST",
        params,
        isAdmin: true
      });
    },
    addAccount({ commit }, params) {
      return post({
        commit,
        url: `/server-back/add_store_user`,
        name: "ADD_ACCOUNT",
        params,
        isAdmin: true
      });
    },
    editAccount({ commit }, params) {
      return post({
        commit,
        url: `/server-back/update_store_user`,
        name: "EDIT_ACCOUNT",
        params,
        isAdmin: true
      });
    },
    deleteAccount({ commit }, params) {
      return post({
        commit,
        url: `/server-back/delete_store_user`,
        name: "DELETE_ACCOUNT",
        params,
        isAdmin: true
      });
    },
    queryDictItemsCode({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=${params.dictCode}`,
        name: "QUERY_DICT_ITEMS_CODE",
        params
      });
    },
    buyServiceProject({ commit }, params) {
      return post({
        commit,
        url: `/store/accountMoney/buyServiceProject`,
        name: "BUY_SERVICE_PROJECT",
        params
      });
    },
    queryAccountMoneyUseRecordList({ commit }, params) {
      return post({
        commit,
        url: `/store/accountMoney/queryAccountMoneyUseRecordList`,
        name: "QUERY_ACCOUNT_MONEY_USE_RECORD_List",
        params
      });
    },
    companyWechatInstall({ commit }, params) {
      return post({
        commit,
        url: `/company/wechat/install`,
        name: "COMPANY_WECHAT_INSTALL",
        params
      });
    },
    queryQywxFriendSwitch({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/qywxAssignSwitch`,
        name: "QUERY_QYWX_FRIEND_SWITCH",
        params
      });
    },
    editQywxFriendSwitch({ commit }, params) {
      return post({
        commit,
        url: `/highSeasMember/qywxAssignSwitchSetting?switchStatus=` + params.val,
        name: "EDIT_QYWX_FRIEND_SWITCH",
        params
      });
    },
    queryBalanceByStoreCode({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/queryBalanceByStoreCode`,
        name: "QUERY_BALANCE",
        params,
        isAdmin: true
      });
    },
    queryAccountWaringInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/accountMoney/queryServiceProjectWarningInfo`,
        name: "QUERY_ACCOUNT_WARING_INFO",
        params,
        isAdmin: true
      });
    },
    storeBasicInfo_info({ commit }, params) {  //查询支付宝账户
      return post({
        commit,
        url: `/storeBasicInfo/info`,
        name: "STOREBASICINFO_INFO",
        params,
        isAdmin: true
      });
    },
    cash_out_apply({ commit }, params) {  //提现提交
      return post({
        commit,
        url: `/storeBasicInfo/cash_out_apply`,
        name: "CASH_OUT_APPLY",
        params,
        isAdmin: true
      });
    },
    cash_out_list({ commit }, params) {  //提现明细列表查询
      return post({
        commit,
        url: `/storeBasicInfo/cash_out/list`,
        name: "CASH_OUT_LIST",
        params,
        isAdmin: true
      });
    },
    cash_out_operate({ commit }, params) {  //提现审核接口
      return post({
        commit,
        url: `/storeBasicInfo/cash_out/operate`,
        name: "CASH_OUT_OPERATE",
        params,
        isAdmin: true
      });
    },
  }
};

export default merchant;
